export default {
    Id: true,
    Name: true,
    Email: true,
    ContactPerson: true,
    Phone: true,
    IdOwnerType: true,
    OwnerType: { Caption: true, LocalizedCaption: true, Name: true },
    OwnerTypes: { Id: true, Caption: true, LocalizedCaption: true, Name: true },
    IdCountry: true,
    Country: { ISO2: true, LocalizedCaption: true, Caption: true, Name: true },
    DateSigned: true,
    HotelChain: {
        Name: true,
    },
    IdCurrency: true,
    Currency: { Name: true },
    Contacts: {
        Id: true,
        Source: true,
        EntityId: true,
        EntityName: true,
        Name: true,
        Email: true,
        Phone: true,
        Position: true,
        ResponseTime: true,
        Notes: true,
    },
};
